import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg {...props}>
      <mask id="mask0_5896_84" maskUnits="userSpaceOnUse" x="0" y="0" width="19" height="19">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H19V19H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5896_84)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9.50006 0C14.7467 0 19 4.25327 19 9.50006C19 14.7467 14.7467 19 9.50006 19C4.25327 19 0 14.7467 0 9.50006C0 4.25327 4.25327 0 9.50006 0ZM9.50006 2.37496C7.74696 2.37261 6.05501 3.01894 4.75003 4.18949V3.26565H3.56255L3.56489 5.93751L5.61922 7.12499L6.21302 6.09659L5.13597 5.47436C7.18533 3.25468 10.5747 2.9277 13.0106 4.71478C15.4465 6.50176 16.1521 9.833 14.6501 12.4542C13.1479 15.0754 9.91708 16.1508 7.14375 14.9528C4.37033 13.7546 2.93886 10.665 3.81784 7.77459L2.76572 7.16657C1.75064 10.095 2.74515 13.3436 5.22549 15.2021C7.70582 17.0605 11.1031 17.1023 13.6285 15.3055C16.1537 13.5086 17.2279 10.2855 16.2852 7.33291C15.3425 4.38037 12.5993 2.37595 9.50006 2.37496ZM9.50006 6.23441H8.31246V10.6875L11.3976 12.4688L11.9914 11.4404L9.50006 10.0012V6.23441Z"
          fill="#FFB246"
        />
      </g>
    </Svg>
  );
};

export default Icon;
